import { render, staticRenderFns } from "./language-button.vue?vue&type=template&id=8c2ee882&scoped=true"
import script from "./language-button.vue?vue&type=script&lang=ts"
export * from "./language-button.vue?vue&type=script&lang=ts"
import style0 from "./language-button.vue?vue&type=style&index=0&id=8c2ee882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2ee882",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
